/**
 * Random Variant Color Cycling v3
 *
 * On page load, finds product cards with data-color-variants attribute
 * and randomly picks a different color for each card. True random
 * distribution — no deterministic hashing, different every page load.
 */
(function () {
  'use strict';

  function init() {
    var cards = document.querySelectorAll('product-card[data-color-variants]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      try {
        var variants = JSON.parse(card.getAttribute('data-color-variants'));
        if (!variants || variants.length <= 1) return;

        // Pick a random variant
        var randomIndex = Math.floor(Math.random() * variants.length);
        var chosen = variants[randomIndex];

        if (!chosen || !chosen.image) return;

        // Swap primary image
        var primaryImg = card.querySelector('.product-card__image--primary');
        if (primaryImg) {
          primaryImg.src = chosen.image;
          primaryImg.srcset = '';
        }

        // Swap secondary image to a different random color
        var secondaryImg = card.querySelector('.product-card__image--secondary');
        if (secondaryImg && variants.length > 1) {
          var secondIndex = randomIndex;
          // Make sure secondary is different from primary
          while (secondIndex === randomIndex && variants.length > 1) {
            secondIndex = Math.floor(Math.random() * variants.length);
          }
          if (variants[secondIndex] && variants[secondIndex].image) {
            secondaryImg.src = variants[secondIndex].image;
            secondaryImg.srcset = '';
          }
        }

        // Swap links to point to the chosen variant
        var links = card.querySelectorAll('a[href*="/products/"]');
        Array.prototype.forEach.call(links, function (link) {
          if (chosen.url) link.href = chosen.url;
        });

        // Save chosen color to card for Globo Swatch sync
        if (chosen.color) {
          card.setAttribute('data-chosen-color', chosen.color.toLowerCase());
        }

      } catch (e) {
        // Silently fail — card stays with default image
      }
    });

    // MutationObserver to sync Globo Swatch once it renders
    var observer = new MutationObserver(function(mutations, obs) {
      var syncedCards = 0;
      cards.forEach(function(card) {
        if (card.hasAttribute('data-synced')) {
          syncedCards++;
          return;
        }
        var chosenColor = card.getAttribute('data-chosen-color');
        if (!chosenColor) {
          card.setAttribute('data-synced', 'true');
          syncedCards++;
          return;
        }

        // Try to find the Globo swatch container
        var globoSwatch = card.querySelector('[class*="globo"] .product_card_swatch_list');
        if (globoSwatch) {
          // Look for the swatch that matches the color
          var swatches = globoSwatch.querySelectorAll('li, li a, li span, li div');
          for (var i = 0; i < swatches.length; i++) {
            var el = swatches[i];
            var value = el.getAttribute('data-value') || el.getAttribute('title') || el.getAttribute('aria-label') || (el.innerText || '').trim();
            if (value && value.toLowerCase() === chosenColor) {
              // Found it! 
              var clickable = el.tagName === 'A' || el.tagName === 'LI' ? el : el.querySelector('a') || el;
              
              // Remove title/tooltips to prevent hover tooltip
              var allElements = globoSwatch.querySelectorAll('*');
              allElements.forEach(function(t) { 
                t.removeAttribute('title'); 
                t.removeAttribute('data-tooltip');
                t.removeAttribute('aria-label');
                t.removeAttribute('data-tippy-content');
              });

              // trigger click to sync state, use interval because Glow JS might load late
              var attempts = 0;
              var syncInterval = setInterval(function() {
                clickable.click();
                attempts++;
                if (attempts > 5) {
                  clearInterval(syncInterval);
                }
              }, 400);
              
              card.setAttribute('data-synced', 'true');
              break;
            }
          }
          // if we couldn't find a matching color, still mark as synced
          if (!card.hasAttribute('data-synced')) {
             card.setAttribute('data-synced', 'true');
          }
        }
      });
      
      // Stop observing if all cards are synced
      if (syncedCards >= cards.length) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Globally strip tooltip attributes from all Globo swatches continuously
    // This ensures no tooltip appears on hover for any swatch.
    setInterval(function() {
      var allGlowSwatches = document.querySelectorAll('[class*="globo"] .product_card_swatch_list *, .globo-swatch-product-card *');
      for (var i = 0; i < allGlowSwatches.length; i++) {
        var t = allGlowSwatches[i];
        if(t.hasAttribute('title')) t.removeAttribute('title');
        if(t.hasAttribute('data-tooltip')) t.removeAttribute('data-tooltip');
        if(t.hasAttribute('aria-label')) t.removeAttribute('aria-label');
        if(t.hasAttribute('data-tippy-content')) t.removeAttribute('data-tippy-content');
      }
      
      // Also hide any active tippy boxes that might have snuck through
      var tippyBoxes = document.querySelectorAll('.tippy-popper, .tippy-box');
      for (var j = 0; j < tippyBoxes.length; j++) {
        var box = tippyBoxes[j];
        if (box.innerText && box.innerText.trim().length < 20) {
           box.style.display = 'none';
        }
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================
   QUICK-BUY MODAL — GLOBO COLOR SWATCH FIX
   Forces Globo Color Swatch to re-initialize
   inside the quick-buy modal after dynamic
   content is loaded.
   ============================================= */
(function() {
  'use strict';

  // ---- DIAGNOSTIC: Scan window for GLO globals ----
  function scanGloboGlobals() {
    var found = [];
    var keys = Object.keys(window);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (/[Gg]lobo|[Gg]cw|[Ss]watch/i.test(k) && typeof window[k] !== 'undefined') {
        found.push({ key: k, type: typeof window[k] });
      }
    }
    if (found.length > 0) {
      console.group('%c[GLO Debug] Detected GLO objects on window:', 'color:#e98da0;font-weight:bold');
      found.forEach(function(f) {
        console.log('  window.' + f.key + '  →  ' + f.type);
      });
      console.groupEnd();
    } else {
      console.warn('[GLO Debug] No GLO objects found on window. The app may not be installed or loaded.');
    }
    return found;
  }

  // ---- CALL ANY GLO FUNCTION ----
  function findAndCallGloboApi(container) {
    var called = false;

    // 1) Scan keys found by diagnostic
    var keys = Object.keys(window);
    var tried = [];

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!/[Gg]lobo|[Gg]cw|[Ss]watch/i.test(k)) continue;

      var val = window[k];
      if (typeof val === 'function') {
        tried.push(k + '()');
        try {
          val.call(window, container);
          called = true;
        } catch(e) {
          try { val.call(window); called = true; } catch(e2) {}
        }
      } else if (val && typeof val === 'object') {
        // Try common method names on this object
        var methods = ['initProductPage', 'init', 'initSwatches', 'reload', 'refresh', 'render'];
        for (var m = 0; m < methods.length; m++) {
          if (typeof val[methods[m]] === 'function') {
            tried.push(k + '.' + methods[m] + '()');
            try {
              val[methods[m]].call(val, container);
              called = true;
            } catch(e) {
              try { val[methods[m]].call(val); called = true; } catch(e2) {}
            }
          }
        }
      }
    }

    // 2) Try known top-level GCW/GloboSwatchPlugin patterns
    var knownPatterns = [
      { obj: window.GloboSwatchPlugin, fns: ['initProductPage', 'initSwatches', 'reload', 'refresh', 'init'] },
      { obj: window.GloboSwatch, fns: ['init', 'refresh', 'reload'] },
      { obj: window.GCW, fns: ['init', 'refresh', 'reload'] },
      { obj: window.globoSwatchPlugin, fns: ['init', 'refresh'] }
    ];
    for (var p = 0; p < knownPatterns.length; p++) {
      var pat = knownPatterns[p];
      if (!pat.obj) continue;
      for (var f = 0; f < pat.fns.length; f++) {
        var fnName = pat.fns[f];
        if (typeof pat.obj[fnName] === 'function' && tried.indexOf(pat.obj.constructor.name + '.' + fnName + '()') === -1) {
          tried.push(pat.obj.constructor.name + '.' + fnName + '()');
          try { pat.obj[fnName].call(pat.obj, container); called = true; } catch(e) {
            try { pat.obj[fnName].call(pat.obj); called = true; } catch(e2) {}
          }
        }
      }
    }

    return called;
  }

  // ---- DISPATCH SHOPIFY EVENTS ----
  function dispatchShopifyEvents(sectionEl) {
    try {
      // Standard Shopify event — apps listen on document, not documentElement
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: {
          sectionId: sectionEl ? sectionEl.id || 'quick-buy-product' : 'quick-buy-product'
        }
      }));
      // Custom event from theme.js
      document.dispatchEvent(new CustomEvent('theme:quick-buy:loaded', {
        bubbles: true,
        detail: { container: sectionEl }
      }));
    } catch(e) {}
  }

  // ---- TRIGGER VARIANT INPUT CHANGES ----
  function triggerVariantInputs(container) {
    if (!container) return;
    // Find all variant radio inputs and selects
    var radios = container.querySelectorAll('input[type="radio"][name*="option"], input[data-option-position]');
    if (radios.length > 0) {
      var checked = container.querySelector('input[type="radio"][name*="option"]:checked, input[data-option-position]:checked');
      if (checked) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var selects = container.querySelectorAll('select[name*="option"]');
    if (selects.length > 0) {
      selects[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ---- MUTATION OBSERVER: watch for GLO swatches ----
  function observeGloboSwatches(container, callback) {
    // Selectors GLO commonly uses for its container output
    var globoSelectors = [
      '.globo-swatch-product-page',
      '.globo-swatch-container',
      '.globo-swatch-list',
      '.globo-style--*',
      '[class*="globo-swatch"]',
      '[class*="globo_swatch"]',
      'ul.swatch-view',
      '.swatch-view'
    ];

    // Check if GLO swatches already exist
    for (var s = 0; s < globoSelectors.length; s++) {
      try {
        if (container.querySelector(globoSelectors[s])) {
          callback(true);
          return null;
        }
      } catch(e) {}
    }

    // Observe for them to appear
    var observer = new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        for (var n = 0; n < mutations[m].addedNodes.length; n++) {
          var node = mutations[m].addedNodes[n];
          if (node.nodeType === 1) {
            for (var s = 0; s < globoSelectors.length; s++) {
              try {
                if (node.matches && node.matches(globoSelectors[s])) {
                  callback(true);
                  observer.disconnect();
                  return;
                }
                if (node.querySelector && node.querySelector(globoSelectors[s])) {
                  callback(true);
                  observer.disconnect();
                  return;
                }
              } catch(e) {}
            }
          }
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
    return observer;
  }

  // ---- MAIN HANDLER ----
  function initGloboInQuickBuyModal(modal) {
    // Run diagnostics once on first use
    if (!window._globoScanned) {
      window._globoScanned = true;
      scanGloboGlobals();
    }

    requestAnimationFrame(function() {
      var content = modal.querySelector('.quick-buy-modal__content') ||
                    modal.querySelector('.quick-buy-modal__info-wrapper') ||
                    modal;

      if (!content) return;

      // Step 1: Dispatch Shopify events so GLO knows new content arrived
      dispatchShopifyEvents(content);

      // Step 2: Try calling any GLO API functions directly
      var apiCalled = findAndCallGloboApi(content);

      // Step 3: Watch for GLO swatches to appear
      var obs = observeGloboSwatches(content, function(swatchesFound) {
        if (swatchesFound) {
          console.log('%c[GLO] Swatches detected in quick-buy modal.', 'color:#4CAF50;font-weight:bold');
          // GLO swatches are already styled via theme.css
        }
        // Cleanup observer once detected
        if (obs) obs.disconnect();
      });

      // Step 4: Retry with delays for async GLO init
      [300, 800, 1500, 3000].forEach(function(delay) {
        setTimeout(function() {
          dispatchShopifyEvents(content);
          findAndCallGloboApi(content);
          if (delay >= 1500) {
            triggerVariantInputs(content);
          }
        }, delay);
      });
    });
  }

  // ---- SET UP LISTENERS ----
  function setupQuickBuyListener() {
    // Listen for the theme's custom dialog event
    document.addEventListener('dialog:after-show', function(e) {
      var modal = e.target;
      if (modal && (modal.tagName === 'QUICK-BUY-MODAL' || modal.classList.contains('quick-buy-modal'))) {
        initGloboInQuickBuyModal(modal);
      }
    });

    // Fallback MutationObserver for modals added dynamically after page load
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (node.tagName === 'QUICK-BUY-MODAL' || node.classList.contains('quick-buy-modal'))) {
            if (node.hasAttribute('open') || node.matches(':popover-open')) {
              initGloboInQuickBuyModal(node);
            }
          }
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQuickBuyListener);
  } else {
    setupQuickBuyListener();
  }
})();
